import Vue from "vue";
import Pnr from "../views/Pnr";
import Home from "../views/Home";
import Login from "../views/Login";
import Sso from "../views/Sso";
import VueRouter from "vue-router";
import { config } from "../config";
import { store } from "../store/store";
import TripsPage from "../views/TripsPage";
import PastTrips from "../views/PastTrips";
import TripDetail from "../views/TripDetail";
import BookTravel from "../views/BookTravel";
import Demos from "../components/Demos/Demos";
import MyTravellers from "../views/MyTravellers";
import ReleaseNotes from "../views/ReleaseNotes";
import PageNotFound from "../views/PageNotFound";
import FlightCancel from "../views/FlightCancel";
import SegmentCancel from "../views/SegmentCancel";
import Meetings from "../components/Meetings/Meetings";
import ManageUsersPage from "../views/ManageUsersPage";
import UserProfilePage from "../views/UserProfilePage";
import AccountSettings from "../views/AccountSettings";
// import Rules from "../components/TravelPolicy/Rules";
import PopperDemo from "../components/Demos/PopperDemo";
import CityPhotos from "../components/Demos/CityPhotos";
import Itinerary from "../components/Itinerary/Itinerary";
import Action from "../components/ActionComponent/Action";
import CarForm from "../components/BookTravel/Car/CarForm";
// import Actions from "../components/TravelPolicy/Actions";
// import Action from "../components/ActionComponent/Action";
import AttendeeInfo from "../components/Meetings/AttendeeInfo";
import Authorization from "../components/Meetings/Authorization";
import FlightForm from "../components/BookTravel/Air/FlightForm";
import HotelForm from "../components/BookTravel/Hotel/HotelForm";
import WhosTraveling from "../components/BookTravel/WhosTraveling";
import Notification from "../components/notifications/Notification";
import PostEventSurvey from "../components/Meetings/PostEventSurvey";
// import BasicDetails from "../components/TravelPolicy/BasicDetails";
import BookingCheckout from "../components/BookTravel/BookingCheckout";
import TravelPolicy from "../components/TravelPolicy/TravelPolicy.vue";
import RegistrationClosed from "../components/Meetings/RegistrationClosed";
import RegistrationSurvey from "../components/Meetings/RegistrationSurvey";
import TravelRequestNotification from "../views/TravelRequestNotification";
import CommonRules from "../components/TravelPolicy/CommonRules/CommonRules";
import CarDailyCost from "../components/TravelPolicy/CommonRules/CarDailyCost";
import TravelPolicyBuilder from "../components/TravelPolicy/TravelPolicyBuilder";
import AssignTravelPolicy from "../components/TravelPolicy/AssignTravelPolicy.vue";
import HotelDailyCost from "../components/TravelPolicy/CommonRules/HotelDailyCost";
import WorldstridesEnvisionAuth from "../components/Meetings/WorldstridesEnvisionAuth";

const guardDevRoutes = (to, from, next) => {
  if (process.env.VUE_APP_HOST === "localhost") return next();
  next({ path: "/home" });
};

const guardTravelPolicyManagerRoutes = (to, from, next) => {
  if (store.getters["app/getActiveUser"]?.isTravelChampion || false) return next();
  next("/*");
};

const guardTravelChampionRoutes = (to, from, next) => {
  if (store.state.travellersAndTrips?.profile?.isTravelChampion || false) return next();
  next({ path: "/home" });
};

const guardMeetingPnrRoutes = (to, from, next) => {
  const isSurvey = to.path === "/meetings/survey";
  const isMeeting = store.state.meetings.meetingInfo;
  const isAttendeeDetails = to.path === "/meetings/attendee-details";
  const isPostEventSurvey = to.path === "/meetings/post-event-survey";
  const isPnrLocator = store.state.meetings.meetingInfo?.pnrRecordLocator || null;
  // const isRegistrationClosed = store.state.meetings.meetingInfo?.meeting?.isRegistrationOpen || false === false;
  const isRegistrationOpen = store.state.meetings.meetingInfo?.meeting?.isRegistrationOpen;

  if (isMeeting) {
    if (isPostEventSurvey) return next();
    if (!isRegistrationOpen) return next({ path: "/meetings/closed" });
    if (isAttendeeDetails || isSurvey) return next();
    if (isPnrLocator) return next({ path: "/meetings/confirmation" });
    return next();
  }

  next({ path: "/meetings" });
};

const bookingRoutes = [
  { path: "action", component: Action, name: "Action" },
  // { path: "rules", component: Rules, name: "Rules" },
  // { path: "actions", component: Actions, name: "Actions" },
  { path: "flights", component: FlightForm, name: "BookingFlights" },
  { path: "itinerary", component: Itinerary, name: "BookingItinerary" },
  { path: "common-rules", component: CommonRules, name: "CommonRules" },
  { path: "car-daily-cost", component: CarDailyCost, name: "CarDailyCost" },
  { path: "checkout", component: BookingCheckout, name: "BookingCheckout" },
  // { path: "basic-details", component: BasicDetails, name: "BasicDetails" },
  { path: "lets-get-going", component: Itinerary, name: "BookingLetsGetGoing" },
  { path: "hotel-daily-cost", component: HotelDailyCost, name: "HotelDailyCost" },
  { path: "whos-traveling", component: WhosTraveling, name: "BookingWhosTraveling" },
  { path: "cars/:recordLocator?", component: CarForm, name: "BookingCars", props: true },
  { path: "travel-policy", component: TravelPolicyBuilder, name: "TravelPolicyBuilder" },
  { path: "hotels/:recordLocator?", component: HotelForm, name: "BookingHotels", props: true },
];

const meetingRoutes = [
  { path: "", component: Authorization, name: "MeetingsAuthorization" },
  { path: "confirmation", component: Pnr, name: "MeetingsConfirmation" },
  { path: "summary", component: BookingCheckout, name: "MeetingsSummary" },
  { path: "closed", component: RegistrationClosed, name: "RegistrationClosed" },
  { path: "attendee-details", component: AttendeeInfo, name: "Meetings", beforeEnter: guardMeetingPnrRoutes },
  { path: "survey", component: RegistrationSurvey, name: "MeetingSurvey", beforeEnter: guardMeetingPnrRoutes },
  { path: "cars", component: CarForm, name: "MeetingCars", props: { meetings: true }, beforeEnter: guardMeetingPnrRoutes },
  { path: "post-event-survey", component: PostEventSurvey, name: "MeetingPostEventSurvey", beforeEnter: guardMeetingPnrRoutes },
  { path: "hotels", component: HotelForm, name: "MeetingHotels", props: { meetings: true }, beforeEnter: guardMeetingPnrRoutes },
  { path: "flights", component: FlightForm, name: "MeetingFlights", props: { meetings: true }, beforeEnter: guardMeetingPnrRoutes },
];

const routes = [
  { path: "", redirect: "/login" },
  { path: "/pnr", component: Pnr },
  { path: "/home", name: "home", component: Home },
  { path: "/my-travelers", component: MyTravellers },
  { path: "/notification", component: Notification },
  { path: "/release-notes", component: ReleaseNotes },
  { path: "/login", name: "login", component: Login },
  { path: "/sso", name: "sso", component: Sso },
  { path: "/approvals", component: TravelRequestNotification },
  { path: "/past-trips", name: "past-trips", component: PastTrips },
  { path: "/meetings", component: Meetings, children: meetingRoutes },
  { path: "/demos", component: Demos, beforeEnter: guardDevRoutes },
  { path: "/planned-trips", name: "planned-trips", component: TripsPage },
  { path: "/admin/account-settings", component: AccountSettings, name: "AccountSettings" },
  { path: "/search", name: "search", component: BookTravel, children: bookingRoutes },
  { path: "/envision", component: WorldstridesEnvisionAuth, name: "WorldstridesEnvisionAuth" },
  { path: "/admin/travel-policy", component: TravelPolicy, beforeEnter: guardTravelPolicyManagerRoutes },
  { path: "/trip-detail/:recordLocatorHash", name: "trip-detail", component: TripDetail, props: true },
  { path: "/demos/popper-demo", component: PopperDemo, name: "PopperDemo", beforeEnter: guardDevRoutes },
  { path: "/admin/travel-policy/:id", component: TravelPolicyBuilder, beforeEnter: guardTravelPolicyManagerRoutes },
  { path: "/admin/assign-travel-policy", component: AssignTravelPolicy, beforeEnter: guardTravelPolicyManagerRoutes },
  { path: "/flight-cancel/:recordLocatorHash/:id", name: "flight-cancel", component: FlightCancel, props: true },
  { path: "/admin/create-travel-policy", component: TravelPolicyBuilder, beforeEnter: guardTravelPolicyManagerRoutes },
  { path: "/admin/users", component: ManageUsersPage, name: "ManageUsersPage", beforeEnter: guardTravelChampionRoutes },
  { path: "/segment-cancel/:recordLocatorHash/:tattoo", name: "segment-cancel", component: SegmentCancel, props: true },
  { path: "/demos/city-photos/:code", component: CityPhotos, name: "CityPhotos", props: true, beforeEnter: guardDevRoutes },
  { path: "/users/:id/profile", component: UserProfilePage, name: "UserProfilePage", props: true, beforeEnter: guardTravelChampionRoutes },
  { path: "/404", name: "404", component: PageNotFound, props: true },
  { path: "*", redirect: { name: 404, params: { resource: "page" } } },
];

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ x: 0, y: 0 }),
});

router.beforeEach((to, from, next) => {
  let entryUrl = null;
  const time = (new Date).getTime();
  const profile = store.state.travellersAndTrips.profile;
  const regex = /(^\/meetings(?:\/((?:[^/]+?)))?(?:\/(?=$))?$)/;
  const expTime = JSON.parse(localStorage.getItem("loginExpireTime"));
  const isAuthenticated = !(profile === null || JSON.stringify(profile) === "{}") && time < expTime;
  const isPublicPath = to.path === "/login" || to.path === "/sso" || to.path === "/envision" || to.path === "/approvals" || to.path.match(regex);

  if (isAuthenticated || isPublicPath) {
    const result = JSON.stringify(store.state.bookTravel.result);
    const empty = JSON.stringify({ flight: {}, car: {}, hotel: {} });
    localStorage.setItem("loginExpireTime", time + config.routerTimer);

    if ((to.path === "/summary" && result === empty) || (isAuthenticated && to.path === "/login")) return next({ path: "/home" });
    if (from.path === "/login" && entryUrl) {
      const url = entryUrl;
      entryUrl = null;
      return next({ path: url });
    }

    return next();
  }

  store.dispatch("clearState/clearState");
  localStorage.removeItem("loginExpireTime");

  if (to.path.match(regex)) entryUrl = to.fullPath;

  next({ path: "/login" });
});

export default router;
